import { defaultTags } from "./tags";

export const formatMoney = (amount, locale = 'en-IN') => {
    return "₹ " + new Intl.NumberFormat(locale).format(amount);
}

export const debounce = (f, ms) => {
    let debounceTimeoutId

    return function (...args) {
        if (debounceTimeoutId) {
            clearTimeout(debounceTimeoutId)
        }

        debounceTimeoutId = setTimeout(() => {
            f.apply(this, args)
        }, ms)
    }
}

export const stringSort = (array, isDescending, column) => {
    if (!array) return [];
    //console.log('array', array);
    return array.slice().sort((a, b) =>
        isDescending
            ? b?.get(column).localeCompare(a.get(column))
            : a?.get(column).localeCompare(b.get(column)));
}

export const numSort = (array, isDescending = true, column) => {
    if (!array) return [];

    return array.slice().sort((a, b) =>
        isDescending
            ? a.get(column) - b.get(column)
            : b.get(column) - a.get(column));
}

export const toggleOffCanvas = (offcanvasName) => {
    const offCanvas = document.getElementById(offcanvasName);
    let offCanvasInstance = bootstrap.Offcanvas.getInstance(offCanvas);
    if (!offCanvasInstance) {
        offCanvasInstance = new bootstrap.Offcanvas(offCanvas);
    }
    offCanvasInstance?.toggle();
}

export const base64ToBlob = (base64, mime) => {
    mime = mime || '';
    const sliceSize = 1024;
    const byteChars = atob(base64);
    const byteArrays = [];

    for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
        const slice = byteChars.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mime });
};

export const sendWAReminder = (account) => {
    const KHATA_URL = process.env.NODE_ENV == "development" ? "http://localhost:3000" : process.env.REACT_APP_URL;

    const num = account.get("phone") || "";
    const link = `Bahi Khata : ${KHATA_URL}/p/${account.id}`;
    window.open(`https://wa.me/${num}?text=${link}`, "_blank");
}

//method to return minDate and it should be atleast 15 min ahed of current time
export const offsetDateByMinutes = (minutes) => {
    const minDate = new Date();
    minDate.setDate(minDate.getDate());
    minDate.setHours(
        minDate.getHours(),
        minDate.getMinutes() + minutes,
        minDate.getSeconds(),
        minDate.getMilliseconds()
    ); // Keep the current time of the day
    return minDate;
}

// Get all unique tags from accounts - Both Active and Closed Accounts.
export const getAllTagsFromAccounts = (_accounts) => {
    if (!_accounts) return [];
    const defaultTagsArr = defaultTags.map((tag) => tag.value);
    const newTags = defaultTagsArr.concat(
        _accounts.map((account) => account.get("tag")).filter((tag) => tag)
    );
    return [...new Set(newTags)];
};